import Vue from 'vue';

Vue.prototype.$PARTNER_TYPE_CONST = 'PARTNER';
Vue.prototype.$CUSTOMER_TYPE_CONST = 'CUSTOMER';
